import {
  Box,
  Paper,
  Typography,
  FormControl,
  TextField,
  Button,
  Snackbar,
} from "@mui/material";
import { LoginFooterLink } from "components/links/LoginFooterLink";
import { ROUTES } from "constants/routes";
import { Formik, Field, Form, FieldProps } from "formik";
import Head from "next/head";
import Image from "next/image";
import { useRouter } from "next/router";
import React from "react";
import { forgotPassword } from "requests/auth";
import formikStyles from "styles/Formik.module.css";
import styles from "styles/Login.module.css";

export default function ForgotPassword() {
  const router = useRouter();
  const formSubmitButtonRef = React.useRef<HTMLButtonElement>(null);
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <Head>
        <title>Forgot Password</title>
        <meta name="description" content="ForgotPassword" />
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <div className={styles.container}>
        <div className={styles.main}>
          <Paper className={styles.box}>
            <div className={styles.logoWrapper}>
              <Image
                src="/NSDS-logo.png"
                alt="Norrizon Logo"
                width={234}
                height={90}
              />
            </div>
            <Typography variant="h2" component="h1" textAlign="center">
              Forgot Password
            </Typography>
            <Typography variant="subtitle1" component="p" textAlign="center">
              Please enter your email address
            </Typography>
            <Formik
              initialValues={{
                email: "",
              }}
              onSubmit={async ({ email }) => {
                await forgotPassword({ email });
                setOpen(true);
                router.push(ROUTES.CONFIRM_PASSWORD);
              }}
            >
              <Form className={formikStyles.form}>
                <Box paddingTop={4}>
                  <Field name="email">
                    {({ field }: FieldProps) => (
                      <FormControl fullWidth>
                        <TextField
                          InputProps={{ ...field }}
                          InputLabelProps={{ shrink: true }}
                          fullWidth
                          id="email"
                          label="Email"
                          variant="outlined"
                          type="email"
                          placeholder="Email address"
                        />
                      </FormControl>
                    )}
                  </Field>
                </Box>
                <Box paddingTop={2} />

                <Button
                  variant="contained"
                  fullWidth
                  component="div"
                  onClick={() => formSubmitButtonRef.current?.click()}
                  // disabled={isSubmitting}
                >
                  <button
                    ref={formSubmitButtonRef}
                    type="submit"
                    // disabled={isSubmitting}
                    style={{ display: "none" }}
                  />
                  Send reset password link
                </Button>

                <div className={styles.bottomLogoWrapper}>
                  <Image
                    src="/login-norrizon-logo-new.JPG"
                    alt="Norrizon Logo"
                    width={164}
                    height={82}
                  />
                </div>

                <Box paddingTop={4}>
                  <LoginFooterLink
                    route={ROUTES.REGISTER}
                    label="Don&lsquo;t have an account?"
                  />
                  &nbsp;&nbsp;
                  <LoginFooterLink route={ROUTES.LOGIN} label="Login" />
                </Box>
                <Snackbar
                  open={open}
                  autoHideDuration={1000}
                  message="Verification Code Sent"
                />
              </Form>
            </Formik>
          </Paper>
        </div>
      </div>
    </>
  );
}
